<template>
    <v-list class="pa-0 pt-3">
        <v-list-item @click="onQuestPreview">
            <v-list-item-title class="text-subtitle-2" :class="{ 'text-center': textCenter }">{{
                $t('Preview')
            }}</v-list-item-title>
        </v-list-item>
        <v-list-item
            :to="{
                name: 'quest-details',
                params: {
                    id: this.quest.id,
                },
            }"
        >
            <v-list-item-title class="text-subtitle-2" :class="{ 'text-center': textCenter }">
                {{ $t('EDIT') }}
            </v-list-item-title>
        </v-list-item>
        <v-list-item @click="onQuestClone">
            <v-list-item-title class="text-subtitle-2" :class="{ 'text-center': textCenter }">
                {{ $t('CREATE COPY') }}
            </v-list-item-title>
        </v-list-item>
        <quest-folder-select-dialog
            text-center
            :quests="[quest.id]"
            :activity-group-id="activityGroup ? activityGroup.id : null"
            @quest-moved="onQuestMove"
        >
            <template #activator="{ on }">
                <v-list-item v-on="on">
                    <v-list-item-title class="text-subtitle-2" :class="{ 'text-center': textCenter }">
                        {{ $t('MOVE TO FOLDER') }}
                    </v-list-item-title>
                </v-list-item>
            </template>
        </quest-folder-select-dialog>
        <v-list-item @click="enableSelectionMode">
            <v-list-item-title class="text-subtitle-2" :class="{ 'text-center': textCenter }">
                {{ $t('SELECT (ALL)') }}
            </v-list-item-title>
        </v-list-item>
        <v-list-item @click="onDisplayDeleteDialog">
            <v-list-item-title class="text-subtitle-2" :class="{ 'text-center': textCenter }">
                {{ $t('Delete') }}
            </v-list-item-title>
        </v-list-item>
        <v-list-item>
            <v-list-item-title class="py-3">
                <v-btn
                    depressed
                    block
                    text
                    class="text-subtitle-2 gray lighten-1"
                    :class="{ 'text-center': textCenter }"
                    @click="$emit('hide-menu')"
                >
                    {{ $t('Cancel') }}
                </v-btn>
            </v-list-item-title>
        </v-list-item>
    </v-list>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { COPY_KEY } from '../config/constants';
import QuestFolderSelectDialog from './QuestFolderSelectDialog';

export default {
    components: {
        QuestFolderSelectDialog,
    },
    props: {
        quest: {
            type: Object,
        },
        textCenter: {
            type: Boolean,
        },
    },
    computed: {
        ...mapState('questList', ['activityGroup']),
    },
    methods: {
        ...mapMutations('questList', ['setSelectedQuests', 'setSelectionMode']),
        ...mapActions('questList', ['cloneQuest']),
        enableSelectionMode() {
            this.setSelectedQuests([this.quest.id]);
            this.setSelectionMode(true);
            this.$emit('hide-menu');
        },
        onQuestPreview() {
            this.$emit('display-quest-preview-dialog');
            this.$emit('hide-menu');
        },
        onQuestClone() {
            this.cloneQuest({ questId: this.quest.id, suffix: this.$t(COPY_KEY) })
                .catch(() => {
                    // TODO: display error notification
                })
                .finally(() => {
                    this.$emit('hide-menu');
                });
        },
        onQuestMove() {
            this.$emit('hide-menu');
        },
        onDisplayDeleteDialog() {
            this.$emit('display-delete-dialog');
        },
    },
};
</script>
